export default __webpack_public_path__ + "static/media/simple3.ba15659b.png";